import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { User } from '../../models/user.model';
import { AddressbookRecord, CallService } from '../../../core/services';

@Component({
  selector: 'spy-call-button',
  templateUrl: './spy-call-button.component.html',
  styleUrls: [
    '../../styles/contact-list/contact-list.scss',
    './spy-call-button.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpyCallButtonComponent implements OnChanges {

  @Input() record: AddressbookRecord;
  @Input() users: User[];
  @Input() extension: string;
  @Input() size: number = 40;
  @Input() alternative: boolean = false;
  @Input() disabled: boolean = false;

  @Output() callStarted: EventEmitter<void> = new EventEmitter();
  
  public userToSpy: User = null;
  private number: string;

  constructor(
    private callService: CallService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateSpyTarget();
  }

  private updateSpyTarget(): void {
    this.userToSpy = null;
    this.number = null;

    if (this.extension && this.users) {
      this.userToSpy = this.users.find((v) => String(v.extension_number) === this.extension);
      this.number = this.extension;
    } else if (this.record && this.users) {
      this.userToSpy = this.users.find((v) => `u${v.id}` === this.record.remoteId);
      this.number = this.record?.defaultNumber?.number;
    }
  }

  public call(event) {
    event.stopPropagation();
    this.callService.callSpyFromNumber(this.number, this.userToSpy.call_spy_callflow.feature_code);
    this.callStarted.emit();
  }

}
